import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import TuneIcon from '@material-ui/icons/Tune';
import { isArray, isEmpty, includes, isNull } from 'lodash';
import PropTypes from 'prop-types';
import qs from 'querystring';
import * as Yup from 'yup';

import { SelectComplete, Spinner } from '~/components';
import {
  Input,
  DateTime,
  Autocomplete,
  Combobox,
  Select,
  InputSlider,
} from '~/components/Form';
import {
  CENTRO_CUSTO_ABASTECIMENTO,
  MOTORISTA_ABASTECIMENTO,
  CAUSA_MANUTENCAO_LUBRIFICANTE,
  OPERACAO_ABASTECIMENTO,
  LOCALIDADE_ABASTECIMENTO,
  TRR_CHILE,
  MODULO_FERROVIA,
  MODULO_CUSTOMIZACAO_VLI,
  CUSTOMIZACAO_RAIZEN,
  SAFRA_ABASTECIMENTO,
} from '~/constants/modules';
import { can, t, validCharacters } from '~/helpers';
import api from '~/services/api';

import { ContainerForm } from './styles';

export default function MyForm({
  data,
  reference,
  close,
  isLoading,
  changeTitle,
}) {
  const [posto, setPosto] = useState(0);
  const [localidadeFixa, setLocalidadeFixa] = useState(null);
  const [veiculo, setVeiculo] = useState(null);
  const [custo, setCusto] = useState(null);
  const [optionsOper, setOptionsOper] = useState([]);
  const [motorista, setMotorista] = useState(null);
  const [totalizador, setTotalizador] = useState(0);
  const [totalizador2, setTotalizador2] = useState(0);
  const [empresaVeiculo, setEmpresaveiculo] = useState(null);
  const [typeProduct, setTypeProduct] = useState('C');
  const [idProduct, setIdProduct] = useState(0);
  const [compartments, setCompartments] = useState([]);
  const [justification, setJustification] = useState(false);
  const [clearFieldOperacao, setClearFieldOperacao] = useState(false);
  const [loadingScreen, setLoadingScreen] = useState(false);
  const [pendingRequests, setPendingRequests] = useState(0);
  const [hasLoadingError, setHasLoadingError] = useState(false);
  const loadingErrorMessage = 's.geral.loadingerror';

  const [exibemotoristaterminal, setExibemotoristaterminal] = useState(0);
  const [
    exibemotoristaempresaveiculoLocal,
    setExibemotoristaempresaveiculoLocal,
  ] = useState(0);
  const [exibeCampoMotorista, setExibeCampoMotorista] = useState(false);

  const [tipoveiculoBase, setTipoveiculoBase] = useState(null);
  const [tipoauxiliarveiculoBase, setTipoauxiliarveiculoBase] = useState(null);
  const [isSafraHabilitado, setIsSafraHabilitado] = useState(false);
  const isLoadingRef = useRef(isLoading);
  const changeTitleRef = useRef(changeTitle);

  const {
    exibeoslubrificacao,
    formaidfrentistaabast,
    exibefrascolubrificacao,
  } = useSelector((state) => state.user.configs);

  const handleAsyncLoadingChange = useCallback(
    (requestLoading) => {
      setPendingRequests((state) => {
        if (hasLoadingError) return 0;
        if (requestLoading) return state + 1;
        return state > 0 ? state - 1 : 0;
      });
    },
    [hasLoadingError]
  );

  const handleAsyncLoadingError = useCallback(() => {
    setHasLoadingError(true);
    setPendingRequests(0);
  }, []);

  const handleTrackApiRequest = useCallback(
    async (request) => {
      handleAsyncLoadingChange(true);

      try {
        return await request();
      } catch (error) {
        handleAsyncLoadingError();
        throw error;
      } finally {
        handleAsyncLoadingChange(false);
      }
    },
    [handleAsyncLoadingChange, handleAsyncLoadingError]
  );

  const handleGetAPIModel = useCallback(
    async (id) => {
      try {
        const response = await handleTrackApiRequest(() =>
          api.get(`/modeloveiculooperacao/operacoes/${id}`, {
            params: { pesquisalista: true },
          })
        );

        setOptionsOper(
          response.data.map((i) => ({
            label: i.descricaooperacao,
            value: i.idoperacao,
          }))
        );
      } catch (err) {
        setOptionsOper([]);
      }
    },
    [handleTrackApiRequest]
  );

  const handleResponseAPIJustification = useCallback(async () => {
    try {
      const response = await handleTrackApiRequest(() =>
        api.get('/justificativascontingencias', {
          params: {
            pagesize: 99999,
            pesquisalista: true,
            wherefield: ['statusjustificativacontingencia'],
            valuewherefield: ['L'],
            typewherefield: ['EQUALS'],
          },
          paramsSerializer: (value) => qs.stringify(value),
        })
      );

      setJustification(!isEmpty(response.data.items));
    } catch (err) {
      setJustification(false);
    }
  }, [handleTrackApiRequest]);

  const handleGetListaSafra = useCallback(async () => {
    try {
      const response = await handleTrackApiRequest(() =>
        api.get('/safras', {
          params: {
            pagesize: 99999,
            wherefield: '',
            typewherefield: '',
            valuewherefield: '',
            pesquisalista: true,
          },
        })
      );

      setIsSafraHabilitado(response.data.items.length > 0);
    } catch (err) {
      setIsSafraHabilitado(false);
    }
  }, [handleTrackApiRequest]);

  const getCompartiments = useCallback(
    async (vehicle, product) => {
      try {
        const response = await handleTrackApiRequest(() =>
          api.get('veiculoscompartimentos', {
            params: {
              wherefield: ['idveiculo', 'idproduto'],
              typewherefield: ['EQUALS', 'EQUALS'],
              valuewherefield: [vehicle, product],
              pesquisalista: true,
            },
            paramsSerializer: (param) => qs.stringify(param),
          })
        );

        setCompartments(
          (response.data.items || []).map((i) => ({
            label: `${i.idcompartimento} - ${i.descricaocompartimento}`,
            value: i.idcompartimento,
          }))
        );
      } catch (err) {
        setCompartments([]);
      }
    },
    [handleTrackApiRequest]
  );

  const handleSetProduct = useCallback((dataProduct) => {
    if (!isEmpty(dataProduct)) {
      setTypeProduct(dataProduct.tipoproduto);
      setIdProduct(dataProduct.idproduto);
    }
  }, []);

  async function handleGetVeiculo() {
    reference.current.setFieldValue('idempresaveiculo', null);
    reference.current.setFieldValue('idcentrocusto', null);
    reference.current.setFieldValue('idoperacao', null);

    if (!veiculo) {
      setEmpresaveiculo('');
      setCusto('');
      setOptionsOper([]);
      return;
    }

    try {
      const response = await handleTrackApiRequest(() =>
        api.get('veiculos', {
          params: {
            wherefield: 'idveiculo',
            typewherefield: 'EQUALS',
            valuewherefield: veiculo,
            pesquisalista: true,
          },
        })
      );

      if (isEmpty(response.data) || isEmpty(response.data.items)) {
        reference.current.setFieldError('idveiculo', 'Veículo não encontrado!');
        setEmpresaveiculo('');
        setOptionsOper([]);
        return;
      }

      const {
        idempresaveiculo,
        nomeempresaveiculo,
        tipototalizadorveiculo,
        tipototalizador2veiculo,
        idcentrocusto,
        idmodeloveiculo,
        tipoveiculo,
        tipoauxiliarveiculo,
        exibemotoristaempresaveiculo,
      } = response.data.items[0];

      if (!can(CUSTOMIZACAO_RAIZEN)) {
        setEmpresaveiculo(nomeempresaveiculo);
      } else {
        setEmpresaveiculo(idempresaveiculo);
      }

      setTotalizador(Number(tipototalizadorveiculo) || 0);
      setTotalizador2(Number(tipototalizador2veiculo) || 0);
      reference.current.setFieldValue('idempresaveiculo', idempresaveiculo);

      if (can(CENTRO_CUSTO_ABASTECIMENTO) && !isEmpty(idcentrocusto)) {
        reference.current.setFieldValue('idcentrocusto', idcentrocusto);
        setCusto(idcentrocusto);
      }

      if (can(OPERACAO_ABASTECIMENTO)) {
        await handleGetAPIModel(idmodeloveiculo);
      }

      setTipoveiculoBase(tipoveiculo);
      setTipoauxiliarveiculoBase(tipoauxiliarveiculo);
      setExibemotoristaempresaveiculoLocal(
        Number(exibemotoristaempresaveiculo) || 0
      );
    } catch (err) {
      setEmpresaveiculo('');
      setOptionsOper([]);
    }
  }

  async function handleValidateCenterCost() {
    if (!custo) return;

    try {
      await handleTrackApiRequest(() =>
        api.get(`centroscustos/${custo}`, { params: { pesquisalista: true } })
      );
    } catch (err) {
      reference.current.setFieldValue('idcentrocusto', null);
      setCusto(null);
      reference.current.setFieldError(
        'idcentrocusto',
        'Centro de Custo não encontrado!'
      );
    }
  }

  async function handleValidateMotorista() {
    if (!motorista) return;

    await api
      .get(`motoristas/${motorista}`, { params: { pesquisalista: true } })
      .catch(async () => {
        reference.current !== null &&
          reference.current.setFieldValue('idmotorista', null);
        setCusto('');

        reference.current !== null &&
          reference.current.setFieldError(
            'idmotorista',
            'Motorista não encontrado!'
          );
      });
  }

  async function handleSubmit(param) {
    setLoadingScreen(true);
    isLoading(true);

    try {
      if (hasLoadingError) {
        toast.error(t(loadingErrorMessage));
        return;
      }

      if (pendingRequests > 0) {
        toast.warning(t('s.geral.validacao.aguardecarregamento'));
        return;
      }

      const schema = Yup.object().shape({
        idveiculo: Yup.string().required(
          t('s.geral.validacao.campoobrigatorio')
        ),
        idempresaveiculo: Yup.string()
          .typeError(t('s.geral.validacao.campoobrigatorio'))
          .required(t('s.geral.validacao.campoobrigatorio')),
        totalizadormovimentacaoabastecimento: includes([1, 2], totalizador)
          ? Yup.string()
            .typeError(t('s.geral.validacao.campoobrigatorio'))
            .required(t('s.geral.validacao.campoobrigatorio'))
          : Yup.string(),
        totalizador2movimentacaoabastecimento: includes([1, 2], totalizador2)
          ? Yup.string()
            .typeError(t('s.geral.validacao.campoobrigatorio'))
            .required(t('s.geral.validacao.campoobrigatorio'))
          : Yup.string(),
        idoperacao:
          can(OPERACAO_ABASTECIMENTO) && !isEmpty(optionsOper)
            ? Yup.string()
              .typeError(t('s.geral.validacao.campoobrigatorio'))
              .required(t('s.geral.validacao.campoobrigatorio'))
            : Yup.string().nullable(),
        codigousuario:
          formaidfrentistaabast !== 0
            ? Yup.string()
              .typeError(t('s.geral.validacao.campoobrigatorio'))
              .test(
                'characters-invalid',
                t('s.configuracao.geral.naopodecontercaracterespecial'),
                (value) => validCharacters(value)
              )
              .required(t('s.geral.validacao.campoobrigatorio'))
            : Yup.string().nullable(),
        idmotorista:
          (!can(CUSTOMIZACAO_RAIZEN) && can(MOTORISTA_ABASTECIMENTO)) ||
            (can(CUSTOMIZACAO_RAIZEN) &&
              can(MOTORISTA_ABASTECIMENTO) &&
              exibeCampoMotorista)
            ? Yup.string()
              .typeError(t('s.geral.validacao.campoobrigatorio'))
              .required(t('s.geral.validacao.campoobrigatorio'))
            : Yup.string().nullable(),
        idcentrocusto: can(CENTRO_CUSTO_ABASTECIMENTO)
          ? Yup.string()
            .typeError(t('s.geral.validacao.campoobrigatorio'))
            .required(t('s.geral.validacao.campoobrigatorio'))
          : Yup.string().nullable(),
        idlocalidade: can(LOCALIDADE_ABASTECIMENTO)
          ? Yup.number()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .typeError(t('s.geral.validacao.campoobrigatorio'))
          : Yup.string(),
        idsafra:
          can(SAFRA_ABASTECIMENTO) && isSafraHabilitado
            ? Yup.number()
              .required(t('s.geral.validacao.campoobrigatorio'))
              .typeError(t('s.geral.validacao.campoobrigatorio'))
            : Yup.string(),
        percentualtanque:
          can(MODULO_FERROVIA) &&
            can(MODULO_CUSTOMIZACAO_VLI) &&
            typeProduct === 'C'
            ? Yup.number()
              .required(t('s.geral.validacao.campoobrigatorio'))
              .typeError(t('s.geral.validacao.campoobrigatorio'))
            : Yup.string(),
        idcompartimento:
          typeProduct === 'C'
            ? Yup.string().nullable()
            : Yup.string()
              .min(1, t('s.geral.validacao.campoobrigatorio'))
              .required(t('s.geral.validacao.campoobrigatorio'))
              .typeError(t('s.geral.validacao.campoobrigatorio')),
        trocalubmovimentacaolubrificacao:
          typeProduct === 'C'
            ? Yup.string().nullable()
            : Yup.number().required(t('s.geral.validacao.campoobrigatorio')),
        numeroosmovimentacaolubrificacao:
          typeProduct === 'L' && exibeoslubrificacao !== 0
            ? Yup.string().required(t('s.geral.validacao.campoobrigatorio'))
            : Yup.string().nullable(),
        idjustificativacontingencia: justification
          ? Yup.string()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .typeError(t('s.geral.validacao.campoobrigatorio'))
          : Yup.string().nullable(),
        frascomovimentacaolubrificacao:
          typeProduct === 'L' && exibefrascolubrificacao === 1
            ? Yup.number()
              .required(t('s.geral.validacao.campoobrigatorio'))
              .min(0, t('s.geral.validacao.valorminimo').replace('%s', 0))
            : Yup.number().nullable(),
        idcausamanutencao:
          typeProduct === 'L' && can(CAUSA_MANUTENCAO_LUBRIFICANTE)
            ? Yup.number()
              .required(t('s.geral.validacao.campoobrigatorio'))
              .min(0, t('s.geral.validacao.valorminimo').replace('%s', 0))
            : Yup.number().nullable(),
      });

      await schema.validate(param, { abortEarly: false });

      const objSend = {
        idmovimentacao: data.idmovimentacao,
        idposto: data.idposto,
        idcliente: param.idcliente || data.idcliente,
        idveiculo: param.idveiculo,
        idempresaveiculo: param.idempresaveiculo,
        idcentrocusto: param.idcentrocusto || data.idcentrocusto,
        idmotorista: param.idmotorista || data.idmotorista,
        idusuario: data.idusuario,
        codigousuario:
          formaidfrentistaabast !== 0
            ? param.codigousuario || data.codigousuario
            : '',
        totalizador: Number(
          param.totalizadormovimentacaoabastecimento ||
          data.totalizadormovimentacaoabastecimento
        ),
        totalizador2: Number(
          param.totalizador2movimentacaoabastecimento ||
          data.totalizador2movimentacaoabastecimento
        ),
        idcompartimento: typeProduct === 'C' ? 0 : param.idcompartimento,
        trocalubmovimentacaolubrificacao:
          typeProduct === 'C' ? 0 : param.trocalubmovimentacaolubrificacao,
        numeroosmovimentacaolubrificacao:
          typeProduct === 'L' && exibeoslubrificacao !== 0
            ? param.numeroosmovimentacaolubrificacao
            : '',
        idoperacao: param.idoperacao,
        idjustificativacontingencia: justification
          ? param.idjustificativacontingencia
          : null,
        percentualtanque:
          can(MODULO_FERROVIA) &&
            typeProduct === 'C' &&
            can(MODULO_CUSTOMIZACAO_VLI)
            ? param.percentualtanque
            : 0,
        frascomovimentacaolubrificacao:
          typeProduct === 'L' ? param.frascomovimentacaolubrificacao : 0,
        idcausamanutencao: typeProduct === 'L' ? param.idcausamanutencao : 0,
        idlocalidade: can(LOCALIDADE_ABASTECIMENTO)
          ? Number(param.idlocalidade) || null
          : null,
      };

      await api.put('transformacoesvazoesemabastecimentos', objSend);
      toast.success(t('s.geral.sucessoalteracao'));
      await close();
    } catch (err) {
      if (isArray(err)) {
        err.map((e) => toast.error(e));
      }

      if (err instanceof Yup.ValidationError) {
        const validationErrors = {};

        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });

        reference.current.setErrors(validationErrors);
      }
    } finally {
      setLoadingScreen(false);
      isLoading(false);
    }
  }

  useEffect(() => {
    if (veiculo && idProduct && typeProduct === 'L') {
      getCompartiments(veiculo, idProduct);
    }
  }, [getCompartiments, idProduct, typeProduct, veiculo]);

  useEffect(() => {
    changeTitleRef.current = changeTitle;
  }, [changeTitle]);

  useEffect(() => {
    changeTitleRef.current(typeProduct);
  }, [typeProduct]);

  useEffect(() => {
    handleResponseAPIJustification();
  }, [handleResponseAPIJustification]);

  useEffect(() => {
    if (can(CUSTOMIZACAO_RAIZEN) && can(MOTORISTA_ABASTECIMENTO)) {
      switch (exibemotoristaterminal ?? 0) {
        case 1:
        case 2:
          setExibeCampoMotorista(true);
          break;
        case 3:
        case 4:
          setExibeCampoMotorista(tipoveiculoBase === 0);
          break;
        case 5:
        case 6:
          setExibeCampoMotorista(tipoveiculoBase === 1);
          break;
        case 7:
        case 8:
          setExibeCampoMotorista(exibemotoristaempresaveiculoLocal > 0);
          break;
        default:
          setExibeCampoMotorista(false);
      }
    }
  }, [
    exibemotoristaempresaveiculoLocal,
    exibemotoristaterminal,
    tipoveiculoBase,
    tipoauxiliarveiculoBase,
  ]);

  useEffect(() => {
    isLoadingRef.current = isLoading;
  }, [isLoading]);

  useEffect(() => {
    if (can(SAFRA_ABASTECIMENTO)) {
      handleGetListaSafra();
    }
  }, [handleGetListaSafra]);

  useEffect(() => {
    isLoadingRef.current(loadingScreen || pendingRequests > 0 || hasLoadingError);
  }, [hasLoadingError, loadingScreen, pendingRequests]);

  useEffect(
    () => () => {
      isLoadingRef.current(false);
    },
    []
  );

  if (hasLoadingError) {
    return (
      <div
        style={{
          border: '1px solid #f5c6cb',
          background: '#f8d7da',
          color: '#721c24',
          borderRadius: '4px',
          padding: '16px',
          lineHeight: 1.5,
        }}
      >
        {t(loadingErrorMessage)}
      </div>
    );
  }

  return (
    <>
      <ContainerForm ref={reference} initialData={data} onSubmit={handleSubmit}>
        <Autocomplete
          disabled
          name="idposto"
          label="nomeposto"
          url="postoscomboios"
          unique="idposto"
          title={t('s.menu.configuracao.posto')}
          getValue={({ idposto, idlocalidade }) => {
            setPosto(idposto || 0);
            setLocalidadeFixa(
              Number(idlocalidade) > 0 ? Number(idlocalidade) : null
            );
          }}
          onLoadingChange={handleAsyncLoadingChange}
          onLoadingError={handleAsyncLoadingError}
        />

        <Combobox
          disabled
          name="idbico"
          label="bicoprodutobico"
          url="bicos"
          unique="idbico"
          title={t('s.menu.configuracao.bico')}
          hiddens={[{ name: 'idterminal' }, { name: 'idproduto' }]}
          params={{
            wherefield: 'idposto',
            valuewherefield: posto || data.idposto,
            typewherefield: 'EQUALS',
            fieldlist:
              'idbico, idterminal, idproduto, bicoprodutobico, tipoproduto, exibemotoristaterminal',
          }}
          getValue={(value) => {
            if (value?.exibemotoristaterminal) {
              setExibemotoristaterminal(value.exibemotoristaterminal);
            } else {
              setExibemotoristaterminal(0);
            }
            handleSetProduct(value);
          }}
          onLoadingChange={handleAsyncLoadingChange}
          onLoadingError={handleAsyncLoadingError}
        />

        <DateTime
          disabled
          time
          name="datahorainicialmovimentacao"
          label={t('s.operacao.abastecimento.datahorainicialmovimentacao')}
        />

        <DateTime
          disabled
          time
          name="datahorafinalmovimentacao"
          label={t('s.operacao.abastecimento.datahorafinalmovimentacao')}
        />

        <Input
          name="idveiculo"
          label={t(
            can(TRR_CHILE)
              ? 's.cadastro.codigoempresacliente'
              : 's.operacao.abastecimento.idveiculo'
          )}
          onKeyUp={({ key }) => key === 'Enter' && handleGetVeiculo()}
          getValue={(value) => {
            setClearFieldOperacao(true);
            setVeiculo(value);
          }}
          onBlur={handleGetVeiculo}
        />

        <Input
          name="idempresaveiculo"
          label={t(
            can(TRR_CHILE)
              ? 's.cadastro.nomeempresacliente'
              : 's.operacao.abastecimento.idempresaveiculo'
          )}
          value={empresaVeiculo}
          disabled
        />

        {can(CENTRO_CUSTO_ABASTECIMENTO) && (
          <Input
            name="idcentrocusto"
            label={t('s.operacao.abastecimento.idcentrocusto')}
            value={custo}
            getValue={(value) => setCusto(value)}
            onBlur={handleValidateCenterCost}
          />
        )}

        {can(SAFRA_ABASTECIMENTO) && (
          <Autocomplete
            name="idsafra"
            title={t('s.geral.camposistema.idsafra')}
            url="safras"
            unique="idsafra"
            label="descricaosafra"
            onLoadingChange={handleAsyncLoadingChange}
            onLoadingError={handleAsyncLoadingError}
          />
        )}

        {can(OPERACAO_ABASTECIMENTO) && (
          <SelectComplete
            disableClearable={!clearFieldOperacao}
            name="idoperacao"
            title={t('s.geral.camposistema.operacaomovimentacaoabastecimento')}
            label="label"
            unique="value"
            dataArray={optionsOper}
            disabled={isNull(veiculo) || isEmpty(veiculo)}
            clearField={clearFieldOperacao}
            getValue={() => setClearFieldOperacao(false)}
          />
        )}

        {can(LOCALIDADE_ABASTECIMENTO) && (
          <Autocomplete
            name="idlocalidade"
            label="nomelocalidade"
            url="localidades"
            unique="idlocalidade"
            title="Localidade"
            disabled={Number(localidadeFixa) > 0}
            forcedValue={
              Number(localidadeFixa) > 0 ? localidadeFixa : undefined
            }
            onLoadingChange={handleAsyncLoadingChange}
            onLoadingError={handleAsyncLoadingError}
          />
        )}

        {includes([1, 2], totalizador) && veiculo && (
          <Input
            name="totalizadormovimentacaoabastecimento"
            type="number"
            label={t(
              `s.operacao.abastecimento.${totalizador === 1 ? 'horimetro' : 'hodometro'
              }`
            )}
            style={{ display: includes([1, 2], totalizador) ? 'block' : 'none' }}
          />
        )}

        {includes([1, 2], totalizador2) && veiculo && (
          <Input
            name="totalizador2movimentacaoabastecimento"
            type="number"
            label={t(
              `s.operacao.abastecimento.${totalizador2 === 1 ? 'horimetro' : 'hodometro'
              }`
            )}
            style={{
              display: includes([1, 2], totalizador2) ? 'block' : 'none',
            }}
          />
        )}

        <Input
          disabled
          name="encerranteinicialmovimentacao"
          label={t('s.operacao.abastecimento.encerranteinicialmovimentacao')}
          type="number"
        />

        <Input
          disabled
          name="encerrantefinalmovimentacao"
          label={t('s.operacao.abastecimento.encerrantefinalmovimentacao')}
          type="number"
        />

        <Input
          disabled
          name="volumemovimentacao"
          label={t('s.operacao.abastecimento.volumemovimentacao')}
          type="number"
        />

        {can(MODULO_FERROVIA) &&
          typeProduct === 'C' &&
          can(MODULO_CUSTOMIZACAO_VLI) && (
            <InputSlider
              name="percentualtanque"
              label={t(
                's.operacao.abastecimento.percentualtanquemovimentacaoabastecimento'
              )}
              width="300px"
              inputWidth="70px"
              labelSize="12px"
              labelVariant="caption"
              icon={TuneIcon}
            />
          )}

        {((!can(CUSTOMIZACAO_RAIZEN) && can(MOTORISTA_ABASTECIMENTO)) ||
          (can(CUSTOMIZACAO_RAIZEN) &&
            can(MOTORISTA_ABASTECIMENTO) &&
            exibeCampoMotorista)) && (
            <Input
              name="idmotorista"
              label={t('s.operacao.abastecimento.idmotorista')}
              getValue={(value) => setMotorista(value)}
              onBlur={handleValidateMotorista}
              onKeyUp={({ key }) => key === 'Enter' && handleValidateMotorista()}
            />
          )}

        {formaidfrentistaabast !== 0 && (
          <Input
            disabled={!isEmpty(data.codigousuario)}
            name="codigousuario"
            label={t('s.operacao.abastecimento.codigousuario')}
          />
        )}

        {typeProduct === 'L' && (
          <>
            <Select
              name="idcompartimento"
              label={t('s.operacao.lubrificacao.idcompartimento')}
              options={compartments}
            />

            <Select
              name="trocalubmovimentacaolubrificacao"
              label={t('s.operacao.lubrificacao.trocalubmovimentacaolubrificacao')}
              options={[
                { label: t('s.geral.opcoes.nao'), value: 0 },
                { label: t('s.geral.opcoes.sim'), value: 1 },
              ]}
            />

            {exibeoslubrificacao === 1 && (
              <Input
                name="numeroosmovimentacaolubrificacao"
                label={t('s.operacao.lubrificacao.numeroosmovimentacaolubrificacao')}
              />
            )}

            {exibefrascolubrificacao === 1 && (
              <Input
                name="frascomovimentacaolubrificacao"
                label={t('s.geral.camposistema.frascomovimentacaolubrificacao')}
                type="number"
              />
            )}

            {can(CAUSA_MANUTENCAO_LUBRIFICANTE) && (
              <Autocomplete
                name="idcausamanutencao"
                label="descricaocausamanutencao"
                url="causasmanutencoes"
                unique="idcausamanutencao"
                title={t('s.menu.cadastro.causamanutencao')}
                params={{
                  orderfield: 'descricaocausamanutencao',
                  wherefield: 'statuscausamanutencao',
                  valuewherefield: 'L',
                  typewherefield: 'EQUALS',
                }}
                onLoadingChange={handleAsyncLoadingChange}
                onLoadingError={handleAsyncLoadingError}
              />
            )}
          </>
        )}

        {justification && (
          <Autocomplete
            name="idjustificativacontingencia"
            url="justificativascontingencias"
            id="idjustificativacontingencia"
            label="descricaojustificativacontingencia"
            unique="idjustificativacontingencia"
            title={t('s.menu.operacao.justificativacontingencia')}
            params={{
              pagesize: 99999,
              pesquisalista: true,
              wherefield: ['statusjustificativacontingencia'],
              valuewherefield: ['L'],
              typewherefield: ['EQUALS'],
            }}
            onLoadingChange={handleAsyncLoadingChange}
            onLoadingError={handleAsyncLoadingError}
          />
        )}
      </ContainerForm>
      <Spinner loading={loadingScreen || pendingRequests > 0} />
    </>
  );
}

MyForm.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  close: PropTypes.func.isRequired,
  isLoading: PropTypes.func.isRequired,
  changeTitle: PropTypes.func.isRequired,
};
